import { useLingui } from '@lingui/react/macro';
import { NotificationType } from 'modules/core/domain/interfaces/supabase/notifications/types';
import { sortOptions, typeOptions } from 'modules/notifications/domain/const';
import UDFormLabeledSelect from 'ud-form/components/labeled-select';
import React, { useMemo } from 'react';
import { NotificationFilters } from 'modules/notifications/domain/interface/notification';

type Props = {
  filters: NotificationFilters;
  onChange: (filters: NotificationFilters) => void;
  className?: string;
};

const NotificationsFilters: React.FC<Props> = ({ filters, onChange, className }) => {
  const { t } = useLingui();
  const translatedTypeOptions = useMemo(() => typeOptions.map((o) => ({ value: o.value, label: t(o.label) })), [t]);
  const translatedSortOptions = useMemo(() => sortOptions.map((o) => ({ value: o.value, label: t(o.label) })), [t]);

  return (
    <div className={`flex items-center gap-4 ${className || ''}`}>
      <UDFormLabeledSelect
        headerText={t`Тип уведомления`}
        options={translatedTypeOptions}
        value={translatedTypeOptions.find((o) => o.value === (filters.type || 'all'))}
        onChange={(opt) => onChange({ ...filters, type: opt?.value as NotificationType | 'all' })}
        style={{ minWidth: 200 }}
      />
      <UDFormLabeledSelect
        headerText={t`Сортировка`}
        options={translatedSortOptions}
        value={translatedSortOptions.find((o) => o.value === (filters.sort || 'desc'))}
        onChange={(opt) => onChange({ ...filters, sort: opt?.value as 'desc' | 'asc' })}
        style={{ minWidth: 120 }}
      />
    </div>
  );
};

export default NotificationsFilters;
